/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Filecategorywhatsappexport4Inputs */

const en_filecategorywhatsappexport4 = /** @type {(inputs: Filecategorywhatsappexport4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`WhatsApp export`)
};

const pt_filecategorywhatsappexport4 = /** @type {(inputs: Filecategorywhatsappexport4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportação WhatsApp`)
};

/**
* | output |
* | --- |
* | "WhatsApp export" |
*
* @param {Filecategorywhatsappexport4Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const filecategorywhatsappexport4 = /** @type {((inputs?: Filecategorywhatsappexport4Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Filecategorywhatsappexport4Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_filecategorywhatsappexport4(inputs)
	return pt_filecategorywhatsappexport4(inputs)
});
export { filecategorywhatsappexport4 as "fileCategoryWhatsAppExport" }